var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-evidents"},[_c('evidence-upload',{attrs:{"caseId":_vm.caseId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }